import React from 'react';
import { useConfig } from '../../../ConfigContext';
import UploadArea from '../UploadArea';
import CropperMultipleComponent from '../CropperMutipleComponent';
import { computeOverlay } from '../../../../utils/overlayMath';
import {
  onCropChange,
  onCropComplete,
  onZoomChange,
  setImageFor,
} from './helpers';
import { ScaleLoader } from 'react-spinners';
import CropperComponent from '../CropperComponent';

export const LayoutGenerator = () => {
  const {
    selectedLayout,
    multipleGap,
    general,
    croppers,
    setCroppers,
    setSelectedMultipleZoomIndex,
    selectedMultipleZoomIndex,
  } = useConfig();
  const { overlayWidth, overlayHeight } = computeOverlay(
    general.glassType,
    general.containerSize
  );

  return (
    <div
      style={{
        height: '100%',
        display: 'grid',
        gridTemplateColumns: selectedLayout.gridTemplateColumns || '1fr',
        gridTemplateRows: selectedLayout.gridTemplateRows || 'repeat(3, 1fr)',
        gridTemplateAreas: selectedLayout.gridTemplateAreas || '',
        rowGap: multipleGap || '10px',
        columnGap: multipleGap || '10px',
      }}
    >
      {croppers.slice(0, selectedLayout.items).map((item, i) => (
        <div
          style={{
            gridArea: `item-${i + 1}`,
          }}
        >
          {item.imageSrc ? (
            <div
              key={i}
              onClick={() => setSelectedMultipleZoomIndex(i)}
              style={{
                width: '100%',
                height: '100%',
              }}
              className={`multiple-crop ${selectedMultipleZoomIndex === i ? 'selected-multiple-zoom-in' : ''}`}
            >
              <CropperMultipleComponent
                itemObject={item}
                overlayWidth={overlayWidth}
                overlayHeight={overlayHeight}
                onZoomChangeFunction={(z) => onZoomChange(setCroppers, i, z)}
                onCropChangeFunction={(c) => onCropChange(setCroppers, i, c)}
                onCropCompleteFunction={(ca, cap) =>
                  onCropComplete(setCroppers, i, ca, cap)
                }
              />
            </div>
          ) : item.imageSrc && item.croppedAreaPixels === null ? (
            <ScaleLoader />
          ) : (
            <UploadArea
              key={i}
              callback={(url) => setImageFor(setCroppers, i, url)}
              style={{
                backgroundColor: 'white',
                color: 'purple',
              }}
            />
          )}
        </div>
      ))}
    </div>
  );
};

export default LayoutGenerator;
